import React, { useState, useEffect } from 'react';
import 'easymde/dist/easymde.min.css';
import { authenticatedUserAddress, isUserSignedIn } from '../../services/auth';
import './style.scss';
import { Snackbar } from '@mui/material';
import Alert from '@mui/material/Alert';
import { validateUsersContract } from '../../services/stacks';
import { clientNetwork } from '../../lib/constants';
import { useParams } from 'react-router-dom';
import ViewExhibit from './ViewExhibit';
import UpdateExhibit from './UpdateExhibit';
import CreateExhibit from './CreateExhibit';
import GiftingModal from '../../components/modal/GiftingModal';
import UserContractDeployModal from '../../components/modal/UserContractDeployModal';
import AdvisoryModal from '../../components/modal/AdvisoryModal';
import WoopsModal from '../../components/modal/WoopsModal';
import ConfirmModal from '../../components/modal/ConfirmModal';

const Exhibit = ({ unAuthAuthor, unAuthFilename }) => {
  const { author, filename } = useParams();
  // Error handler
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [openInlineErrorBar, setOpenInlineErrorBar] = useState(false);
  const [errorMsg, setErrorMsg] = useState({ severity: '', msg: '' });
  const [isLoading, setIsLoading] = useState(true);

  const [userContractStatus, setUserContractStatus] = useState('');
  const [txId, setTxId] = useState('');
  const [tx_Id, setTx_Id] = useState('');

  const [showUserContractDeployModal, setShowUserContractDeployModal] = useState(false);
  const [showAdvisoryModal, setShowAdvisoryModal] = useState(false);
  const [showWoopsModal, setShowWoopsModal] = useState(false);
  const [showGiftingModal, setShowGiftingModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  async function validating(open, value, userStorage) {
    const { state, txId } = await validateUsersContract(userStorage);
    console.log(state, txId);
    if (!isLoading) setTxId(txId);
    setUserContractStatus(state);
    console.log({ state });
    switch (state) {
      case true:
        open(value);
        break;
      case false:
      case 'success':
      case 'mempool':
      case 'abort_by_post_condition':
      case 'abort_by_response':
        setShowUserContractDeployModal(true);
        break;
      case 'updateNeeded':
        setShowAdvisoryModal(true);
        break;
      default:
        if (isUserSignedIn()) {
          setShowUserContractDeployModal(true);
        } else {
          console.log("Whoops modal");
          setShowWoopsModal(true);
        }
        break;
    }
  }

  function handleCloseSnackBar() { setOpenSnackBar(false); }

  useEffect(() => {
    validating(setIsLoading, true);
  }, [])

  useEffect(() => {
    console.log(userContractStatus);
  }, [userContractStatus])

  return (
    <>
      <div className='exhibit-container'>

        {((author && filename) || (unAuthAuthor && unAuthFilename)) &&
          <ViewExhibit
            author={author || unAuthAuthor}
            fileName={filename || unAuthFilename}
            userContractStatus={userContractStatus}

            // Modal States
            setShowGiftingModal={setShowGiftingModal}
            setShowUserContractDeployModal={setShowUserContractDeployModal}
            setShowAdvisoryModal={setShowAdvisoryModal}
            setShowWoopsModal={setShowWoopsModal}
            // Error States
            setOpenInlineErrorBar={setOpenInlineErrorBar}
            setErrorMsg={setErrorMsg}
            setOpenSnackBar={setOpenSnackBar}

            profileAddress={author || unAuthAuthor}
          />}

        {(filename && !author) && <UpdateExhibit setErrorMsg={setErrorMsg} setOpenSnackBar={setOpenSnackBar} fileName={filename} />}
        {((!filename && !author) && (!unAuthFilename && !unAuthAuthor)) && <CreateExhibit setErrorMsg={setErrorMsg} setOpenSnackBar={setOpenSnackBar} />}

        {openInlineErrorBar &&
          <Alert onClose={() => setOpenInlineErrorBar(false)} variant="filled" severity={errorMsg.severity} sx={{ width: '100%' }}>
            {errorMsg.msg}
          </Alert>
        }
      </div>

      {/* Snack bar joint */}
      <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={handleCloseSnackBar} sx={{ zIndex: '100001' }}>
        <Alert onClose={handleCloseSnackBar} severity={errorMsg?.severity} sx={{ width: '100%' }}>
          {errorMsg?.msg}
        </Alert>
      </Snackbar>

      {showGiftingModal && <GiftingModal show={showGiftingModal} setShow={setShowGiftingModal} authorPrincipal={author || unAuthAuthor} giftVia={`Exhibit::${filename || unAuthFilename}`} />}
      {showUserContractDeployModal && <UserContractDeployModal userContractStatus={userContractStatus} show={showUserContractDeployModal} setShow={setShowUserContractDeployModal} setTxId={setTxId} setTx_Id={setTx_Id} openConfirmModal={setShowConfirmModal} />}
      {showConfirmModal && <ConfirmModal show={showConfirmModal} setShow={setShowConfirmModal} txId={txId} close={() => setShowConfirmModal(false)} />}
      {showAdvisoryModal && <AdvisoryModal show={showAdvisoryModal} close={() => setShowAdvisoryModal(false)} />}
      {showWoopsModal && <WoopsModal show={showWoopsModal} setShow={setShowWoopsModal} close={() => setShowWoopsModal(false)} />}
    </>

  );
};

export default Exhibit;